document.addEventListener('DOMContentLoaded', function () {
  // Helper function to add "Other" field behavior
  function handleOtherInput(labelSelector, inputSelector, excludeRadioId) {
      const otherLabel = document.querySelector(labelSelector);
      const otherInput = document.querySelector(inputSelector);

      if (otherLabel && otherInput) {
          // Ensure the input is visible before focusing
          otherLabel.addEventListener('click', function () {
              otherInput.classList.add('show'); // Add a class to ensure visibility
              setTimeout(() => {
                  // Delay focus slightly to ensure visibility
                  otherInput.focus();
              }, 0);
          });

          // Restrict input to numerical values only
          otherInput.addEventListener('input', function () {
              this.value = this.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters
          });

          // Reset "Other" field when another radio button is clicked
          const radioButtons = document.querySelectorAll('.gfield-choice-input');
          radioButtons.forEach((radio) => {
              if (radio.id !== excludeRadioId) {
                  radio.addEventListener('click', function () {
                      otherInput.classList.remove('show'); // Hide the input field
                      otherInput.value = ''; // Clear the input value
                  });
              }
          });
      }
  }

  // Apply behavior for English "Other" input
  handleOtherInput('label[for="choice_154_10_3"]', '#input_154_10_other', 'choice_154_10_3'); // Monthly on Staging
  handleOtherInput('label[for="choice_154_11_3"]', '#input_154_11_other', 'choice_154_11_3'); // Annual on Staging

  handleOtherInput('label[for="choice_95_10_3"]', '#input_95_10_other', 'choice_95_10_3'); // Monthly on local
  handleOtherInput('label[for="choice_95_11_3"]', '#input_95_11_other', 'choice_95_11_3'); // Annual on local
  
  //production english
  handleOtherInput('label[for="choice_160_10_3"]', '#input_160_10_other', 'choice_160_10_3'); // Monthly on production
  handleOtherInput('label[for="choice_160_11_3"]', '#input_160_11_other', 'choice_160_11_3'); // Annual on production


  // Apply behavior for French "Other" input
  handleOtherInput('label[for="choice_155_10_3"]', '#input_155_10_other', 'choice_155_10_3'); // Monthly on Staging
  handleOtherInput('label[for="choice_155_11_3"]', '#input_155_11_other', 'choice_155_11_3'); // Annual on Staging



    //production english
    handleOtherInput('label[for="choice_160_10_3"]', '#input_160_10_other', 'choice_160_10_3'); // Monthly on production
    handleOtherInput('label[for="choice_160_11_3"]', '#input_160_11_other', 'choice_160_11_3'); // Annual on production

      //production french
  handleOtherInput('label[for="choice_161_10_3"]', '#input_161_10_other', 'choice_161_10_3'); // Monthly on production
  handleOtherInput('label[for="choice_161_11_3"]', '#input_161_11_other', 'choice_161_11_3'); // Annual on production
});



// WEBPACK FOOTER //
// ./src/js/vanilla/gravity-forms-other-button.js